/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Check_Version_InformationInputs */

const en_directory_agent_readiness_check_version_information = /** @type {(inputs: Directory_Agent_Readiness_Check_Version_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Version information`)
};

const zh_directory_agent_readiness_check_version_information = /** @type {(inputs: Directory_Agent_Readiness_Check_Version_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`版本信息`)
};

/**
* | output |
* | --- |
* | "Version information" |
*
* @param {Directory_Agent_Readiness_Check_Version_InformationInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_check_version_information = /** @type {((inputs?: Directory_Agent_Readiness_Check_Version_InformationInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Check_Version_InformationInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_check_version_information(inputs)
	return zh_directory_agent_readiness_check_version_information(inputs)
});
export { directory_agent_readiness_check_version_information as "directory.agent_readiness.check.version_information" }